/* IP artwork viewer and native-contact context. No libraries or form submission. */
(() => {
  if (!customElements.get('octas-ip-gallery')) {
    class OctasIPGallery extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.links = Array.from(this.querySelectorAll('[data-ip-gallery-item]'));
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.image = this.querySelector('[data-ip-gallery-image]');
        this.counter = this.querySelector('[data-ip-gallery-counter]');
        this.original = this.querySelector('[data-ip-gallery-original]');
        this.previous = this.querySelector('[data-ip-gallery-previous]');
        this.next = this.querySelector('[data-ip-gallery-next]');
        this.links.forEach((link, index) => {
          link.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
            event.preventDefault();
            this.opener = link;
            this.showImage(index);
            this.dialog.showModal();
          }, options);
        });
        this.querySelector('[data-ip-gallery-close]').addEventListener('click', () => this.dialog.close(), options);
        this.previous.addEventListener('click', () => this.showImage(this.index - 1), options);
        this.next.addEventListener('click', () => this.showImage(this.index + 1), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showImage(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      }
      showImage(index) {
        this.index = (index + this.links.length) % this.links.length;
        const link = this.links[this.index];
        this.image.src = link.href;
        this.image.alt = link.querySelector('img')?.alt || '';
        this.original.href = link.href;
        this.counter.textContent = `${this.index + 1} / ${this.links.length}`;
        this.previous.disabled = this.next.disabled = this.links.length < 2;
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.controller?.abort();
      }
    }
    customElements.define('octas-ip-gallery', OctasIPGallery);
  }

  const addInquiryContext = () => {
    if (!document.body.classList.contains('octas-interior--contact')) return;
    const ip = new URLSearchParams(location.search).get('ip')?.trim().slice(0, 200);
    const fields = document.querySelector('.octas-contact__fields');
    if (!ip || !fields || fields.querySelector('[name="contact[IP of interest]"]')) return;
    const field = document.createElement('div');
    field.className = 'octas-contact__field octas-contact__field--full';
    const label = document.createElement('label');
    label.htmlFor = 'OctasContactIP';
    label.textContent = 'IP of interest';
    const input = document.createElement('input');
    input.className = 'octas-contact__input';
    input.id = label.htmlFor;
    input.name = 'contact[IP of interest]';
    input.type = 'text';
    input.value = ip;
    input.maxLength = 200;
    field.append(label, input);
    const message = fields.querySelector('[name="contact[body]"]')?.closest('.octas-contact__field');
    fields.insertBefore(field, message || null);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addInquiryContext, { once: true });
  else addInquiryContext();
  document.addEventListener('shopify:section:load', addInquiryContext);
})();
